export default "__VITE_ASSET__DrB2Xk9R__"